import { useState } from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

/**
 * Dialog body for a secret the API returns exactly once (an API key, a generated password).
 * The secret lives in the caller's state only; closing the dialog must drop it.
 */
export function OneTimeSecretContent({
  title,
  warning,
  secret,
  onDone,
}: {
  title: string;
  warning: string;
  secret: string;
  onDone: () => void;
}) {
  const [copied, setCopied] = useState(false);
  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
      </DialogHeader>
      <Alert variant="destructive">
        <AlertDescription>{warning}</AlertDescription>
      </Alert>
      <div className="rounded-lg border bg-muted p-3 font-mono text-sm break-all">{secret}</div>
      <DialogFooter>
        <Button
          variant="outline"
          onClick={() => {
            void navigator.clipboard.writeText(secret);
            setCopied(true);
          }}
        >
          {copied ? 'Copied' : 'Copy to clipboard'}
        </Button>
        <Button onClick={onDone}>Done</Button>
      </DialogFooter>
    </DialogContent>
  );
}
